import { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { useQueryGetRolesList } from 'api/queries/getRolesList.query';

import MainTable from 'components/common/Tables/MainTable/MainTable';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import { Button } from 'components/DesignSystem/Button';
import classes from 'components/Settings/Components/RolesManagement/components/rolesManagement.module.scss';
import {
    columns,
    defaultColumn,
    initialState,
} from 'components/Settings/Components/RolesManagement/rolesManagement.utils';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const RolesManagement = () => {
    const { data: rolesList, isLoading, isFetching } = useQueryGetRolesList();
    const history = useHistory();
    const { pathname } = useLocation();

    const handleNew = (): void => {
        history.push(`${pathname}/${settingsConfig.roleManagementNewRole.link}`);
    };

    const data = useMemo(() => {
        return rolesList || [];
    }, [rolesList]);

    return (
        <WidgetWithTitle
            id={'rolesManagement'}
            title={'Role Management'}
            titleComponents={[
                <div className={classes.titleActions} key={'addRoleCallback'}>
                    <Button onClick={handleNew}>Add Role</Button>
                </div>,
            ]}
        >
            <div className={classes.container}>
                <MainTable
                    columns={columns}
                    data={data}
                    initialState={initialState}
                    defaultColumn={defaultColumn}
                    isLoading={isLoading || isFetching}
                />
            </div>
        </WidgetWithTitle>
    );
};
